import * as React from "react";
import RadioButton from "./components/radio-button";

const RadioButtonSkeletonLoading = ({ numberOfRadios = 1 }) => {
  const radios = [];
  for (let i = 0; i < numberOfRadios; i += 1) {
    radios.push(
      <RadioButton
        key={`radio-loader-${i}`}
        text="loading"
        value="loading"
        onClick={undefined}
        isLoading
      />
    );
  }

  return <>{radios}</>;
};

export default RadioButtonSkeletonLoading;
